import { useNavigate } from "react-router-dom";
import { ChevronRight, SearchX } from "lucide-react";
import { PersonaBadge } from "../Badges";

const goTo = (navigate, id) => navigate(`/clientes/${encodeURIComponent(id)}`);

const EmptyState = () => (
  <div className="flex flex-col items-center gap-2 px-4 py-14 text-center" data-testid="clients-empty-state">
    <SearchX className="h-8 w-8 text-[#9bc1ff]" />
    <p className="text-base font-bold text-[#182235]">No se encontraron clientes</p>
    <p className="text-sm text-[#5b667a]">Revisa el nombre, ID de cliente o ID de crédito.</p>
  </div>
);

const MobileList = ({ items, navigate }) => (
  <ul className="divide-y divide-[#e8edf5] md:hidden" data-testid="clients-mobile-list">
    {items.map((c) => (
      <li key={c.borrower_id}>
        <button type="button" onClick={() => goTo(navigate, c.borrower_id)} data-testid={`client-card-${c.borrower_id}`} className="flex w-full items-center gap-3 px-4 py-3.5 text-left hover:bg-[#f5f8fc]">
          <div className="min-w-0 flex-1 space-y-1.5">
            <div className="truncate text-sm font-bold text-[#182235]">{c.name}</div>
            <div className="flex flex-wrap items-center gap-1.5 text-xs text-[#5b667a]">
              <span className="font-mono">{c.borrower_id}</span>·<span>{c.loan_count} {c.loan_count === 1 ? "crédito" : "créditos"}</span>
            </div>
            <div className="flex flex-wrap gap-1.5">
              <PersonaBadge persona={c.persona} label={c.persona_label} />
            </div>
          </div>
          <ChevronRight className="h-4 w-4 shrink-0 text-[#9bc1ff]" />
        </button>
      </li>
    ))}
  </ul>
);

const DesktopTable = ({ items, navigate }) => (
  <table className="hidden w-full text-sm md:table" data-testid="clients-table">
    <thead>
      <tr className="border-b border-[#e8edf5] bg-[#f8fafd] text-left text-xs font-bold uppercase tracking-[0.04em] text-[#5b667a]">
        <th className="px-5 py-3">Cliente</th>
        <th className="px-5 py-3">ID cliente</th>
        <th className="px-5 py-3">Tipo</th>
        <th className="px-5 py-3 text-center">Créditos</th>
        <th className="w-10 px-3 py-3" aria-label="Abrir" />
      </tr>
    </thead>
    <tbody className="divide-y divide-[#eef2f7]">
      {items.map((c) => (
        <tr key={c.borrower_id} onClick={() => goTo(navigate, c.borrower_id)} data-testid={`client-row-${c.borrower_id}`} className="group cursor-pointer transition-colors hover:bg-[#f5f8fc]">
          <td className="px-5 py-3.5 font-semibold text-[#182235] group-hover:text-[#0a47be]" data-testid={`client-row-name-${c.borrower_id}`}>{c.name}</td>
          <td className="px-5 py-3.5 font-mono text-xs text-[#3b475c]">{c.borrower_id}</td>
          <td className="px-5 py-3.5"><PersonaBadge persona={c.persona} label={c.persona_label} testId={`client-row-tipo-${c.borrower_id}`} /></td>
          <td className="px-5 py-3.5 text-center font-semibold" data-testid={`client-row-creditos-${c.borrower_id}`}>{c.loan_count}</td>
          <td className="px-3 py-3.5"><ChevronRight className="h-4 w-4 text-[#9bc1ff] transition-transform group-hover:translate-x-0.5" /></td>
        </tr>
      ))}
    </tbody>
  </table>
);

export const ClientTable = ({ items }) => {
  const navigate = useNavigate();
  if (!items.length) return <EmptyState />;
  return (
    <>
      <DesktopTable items={items} navigate={navigate} />
      <MobileList items={items} navigate={navigate} />
    </>
  );
};
